import React from "react";
import { StravaIcon } from "./StravaConnectButton";

export function StravaBadge({ className = "", showText = true }) {
  return (
    <span
      title="Dados importados do Strava"
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium bg-[#FC4C02]/15 text-[#FC4C02] border border-[#FC4C02]/30 ${className}`}
    >
      <StravaIcon className="w-3.5 h-3.5 flex-shrink-0" />
      {showText && <span>Strava</span>}
    </span>
  );
}

export default StravaBadge;
